import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import { COLOR, GRAPH_COLOR } from '@common/constants'
import moment from 'moment-timezone'

export default ({ dataSeries, totalData }) => {

    return (
        <ReactApexChart
            options={{
                ...defaultChartOption,
                chart: { id: 'alert-min-chart', group: 'historical-alert-page-chart', type: 'bar' },
                stroke: { curve: 'smooth', width: 0, },
                subtitle:
                {
                    text: `Total: ${totalData}`,
                    align: 'left',
                    margin: 10,
                    offsetX: 30,
                    offsetY: 0,
                    style:
                    {
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: COLOR.REDLIGHT
                    },
                },
                grid: { ...defaultChartOption.grid, padding: { left: 25 } },
                stroke: { width: 1.5, curve: 'stepline', },
                colors: [GRAPH_COLOR.ALERT],
                yaxis: alertYaxis,
                legend:
                {
                    position: 'top',
                    horizontalAlign: 'left',
                    offsetX: 20
                },
            }}
            series={dataSeries}
            height={180}
            type='area'
        />
    )
}



const defaultChartOption = {
    chart: {
        height: 350,
        animations: { enabled: true },
        autoScaleYaxis: true
    },
    dataLabels: {
        enabled: false
    },
    markers: { size: 0 },
    legend: {
        show: false,
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 20
    },
    xaxis: {
        type: 'datetime',
        labels: {
            datetimeUTC : false,
            style: {
                colors: COLOR.DARKGREY,
            }
        }
    },
    tooltip: {
        x: {
            format: 'dd/MM/yy HH:mm',
        },
    },
    grid: {
        yaxis: {
            lines: {
                offsetX: -10,
                show: true
            },
        },
        xaxis: {
            lines: {
                show: true,
            },
            labels: {
                style: {
                    colors: COLOR.DARKGREY,
                },
                offsetY: 0,
                offsetX: 0,
                axisBorder: {
                    show: true,
                },
            },
        },
        padding: {
            left: 20,
            Right: 45
        },
        strokeDashArray: 5,
    },
}


const alertYaxis = {
    tickAmount: 1,
    min: 0,
    floating: false,
    axisBorder: {
        show: true
    },
    axisTicks: {
        show: true
    },
    labels: {
        style: {
            colors: COLOR.DARKGREY,
        },
    },
    title: {
        text: 'Alert (Min)',
        style: { color: COLOR.TMD_GREY }
    }
}


